import * as z from 'zod';

export const SetCurrenciesRequest = z.object({
  options: z
    .object({
      currencies: z
        .array(
          z.object({
            code: z
              .string()
              .describe(
                'Three-letter currency code, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.'
              )
              .max(3)
              .optional(),
          })
        )
        .max(156)
        .optional(),
    })
    .optional(),
});
export const SetCurrenciesResponse = z.object({});
export const GetCurrenciesRequest = z.object({});
export const GetCurrenciesResponse = z.object({
  currencies: z
    .array(
      z.object({
        code: z
          .string()
          .describe(
            'Three-letter currency code, in [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes) format.'
          )
          .max(3)
          .optional(),
      })
    )
    .optional(),
});
